import { render, staticRenderFns } from "./CreditsViewer.vue?vue&type=template&id=0485e7e8&"
import script from "./CreditsViewer.vue?vue&type=script&lang=ts&"
export * from "./CreditsViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports